import homesideBrand from './customers/homeside/theme/theme';
import lowerBrand from './customers/lower/theme/theme';
import lwrBrand from './customers/lwr/theme/theme';
import defaultBrand from './customers/default/theme/theme';
import ozlendingBrand from './customers/ozlending/theme/theme';
import opendoorBrand from './customers/opendoor/theme/theme';
import powertpoBrand from './customers/powertpo/theme/theme';

const brand = {
  DefaultBrand: defaultBrand,
  HomesideBrand: homesideBrand,
  LowerBrand: lowerBrand,
  LwrBrand: lwrBrand,
  OpendoorBrand: opendoorBrand,
  OzLendingBrand: ozlendingBrand,
  PowerTpoBrand: powertpoBrand,
};

export default brand;
